module.exports = __webpack_public_path__ + "img/icon_map_38_off_110.787b0274.png";